import React from "react";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "@/components/ui/tabs";
import { Users, ClipboardList, UserCheck, BookUser } from "lucide-react";
import StaffRolesTab from "@/components/admin/staffing/StaffRolesTab";
import EventStaffNeedsTab from "@/components/admin/staffing/EventStaffNeedsTab";
import AssignmentsTab from "@/components/admin/staffing/AssignmentsTab";
import StaffDirectoryTab from "@/components/admin/staffing/StaffDirectoryTab";

const EventManagementStaffing: React.FC = () => {
  return (
    <div className="space-y-6">
      <div>
        <h1 className="text-2xl font-bold text-foreground flex items-center gap-2">
          <Users className="h-6 w-6 text-secondary" />
          Staffing
        </h1>
        <p className="text-muted-foreground mt-1">
          Manage staff roles, plan event staffing needs, and assign team members to positions.
        </p>
      </div>

      <Tabs defaultValue="roles">
        <TabsList className="grid w-full grid-cols-4">
          <TabsTrigger value="roles" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <ClipboardList className="h-4 w-4" />
            <span className="hidden sm:inline">Staff Roles</span>
            <span className="sm:hidden">Roles</span>
          </TabsTrigger>
          <TabsTrigger value="needs" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <Users className="h-4 w-4" />
            <span className="hidden sm:inline">Event Staff Needs</span>
            <span className="sm:hidden">Needs</span>
          </TabsTrigger>
          <TabsTrigger value="assignments" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <UserCheck className="h-4 w-4" />
            <span className="hidden sm:inline">Assignments</span>
            <span className="sm:hidden">Assign</span>
          </TabsTrigger>
          <TabsTrigger value="directory" className="flex items-center gap-1.5 text-xs sm:text-sm">
            <BookUser className="h-4 w-4" />
            <span className="hidden sm:inline">Staff Directory</span>
            <span className="sm:hidden">Directory</span>
          </TabsTrigger>
        </TabsList>

        <TabsContent value="roles" className="mt-6">
          <StaffRolesTab />
        </TabsContent>
        <TabsContent value="needs" className="mt-6">
          <EventStaffNeedsTab />
        </TabsContent>
        <TabsContent value="assignments" className="mt-6">
          <AssignmentsTab />
        </TabsContent>
        <TabsContent value="directory" className="mt-6">
          <StaffDirectoryTab />
        </TabsContent>
      </Tabs>
    </div>
  );
};

export default EventManagementStaffing;
